import * as actions from '../actionTypes'

const initialState = {
  fineNumber: '',
  confirmFineNumber: '',
  paymentAmount: '',
  paymentAmountFull: '',
  fineOwing: '',
  minPaymentAmount: '',
  caseSotId: '',
  receiptDetail: '',
  fineType: '',
  fines: [],
  editFineNumber: '',
  emailAddress: '',
  confirmEmailAddress: '',
}

const AppReducer = (state = initialState, action) => {
  switch (action.type) {
    case actions.FINE_NUMBER: {
      return {
        ...state,
        fineNumber: action.payload.description,
      }
    }
    case actions.CONFIRM_FINE_NUMBER: {
      return {
        ...state,
        confirmFineNumber: action.payload.description,
      }
    }
    case actions.FINE_OWING: {
      return {
        ...state,
        fineOwing: action.payload.description,
      }
    }
    case actions.PAYMENT_AMOUNT: {
      return {
        ...state,
        paymentAmount: action.payload.description,
      }
    }
    case actions.PAYMENT_AMOUNT_FULL: {
      return {
        ...state,
        paymentAmountFull: action.payload.description,
      }
    }
    case actions.MIN_PAYMENT_AMOUNT: {
      return {
        ...state,
        minPaymentAmount: action.payload.description,
      }
    }
    case actions.CASE_SOT_ID: {
      return {
        ...state,
        caseSotId: action.payload.description,
      }
    }
    case actions.RECEIPT_DETAIL: {
      return {
        ...state,
        receiptDetail: action.payload.description,
      }
    }
    case actions.FINE_TYPE: {
      return {
        ...state,
        fineType: action.payload.description,
      }
    }
    case actions.EMAIL_ADDRESS: {
      return {
        ...state,
        emailAddress: action.payload.description,
      }
    }
    case actions.CONFIRM_EMAIL_ADDRESS: {
      return {
        ...state,
        confirmEmailAddress: action.payload.description,
      }
    }
    case actions.EDIT_FINE_NUMBER: {
      return {
        ...state,
        editFineNumber: action.payload.fineNumber,
      }
    }
    case actions.ADD_FINE: {
      const newFine = action.payload
      if(newFine.fineNumber) {
        return {
          ...state,
          fines: [...state.fines.filter((fine) => fine.fineNumber !== newFine.fineNumber), newFine]
        };
      }
    }
    case actions.EDIT_FINE: {
      return {
        ...state,
        fines: state.fines.map((fine) => (fine.fineNumber === state.editFineNumber ? action.payload : fine)),
      }
    }
    case actions.DELETE_FINE: {
      return {
        ...state,
        fines: state.fines.filter((fine) => fine.fineNumber !== action.payload.fineNumber),
      }
    }
    case actions.CLEAR_FINE_INFO: {
      return {
        ...state,
        fineNumber: initialState.fineNumber,
        confirmFineNumber: initialState.confirmFineNumber,
        paymentAmount: initialState.paymentAmount,
        minPaymentAmount: initialState.minPaymentAmount,
        fineOwing: initialState.fineOwing,
        caseSotId: initialState.caseSotId,
        receiptDetail: initialState.receiptDetail,
        fineType: initialState.fineType,
      }
    }
    case actions.CLEAR_ALL: {
      return initialState
    }
    default: {
      return state
    }
  }
}
export default AppReducer
